import React, { useEffect } from 'react';
import {configuratorState, setSelectedMaterial, setCurrentModelMaterialSpecifications,setFinish} from "../../../../state";
import {useSnapshot} from "valtio";
import SwatchBtn from "./SwatchBtn";

const SwatchesNavController = () => {
  
  const {partSelected, activeWall,selectedMaterialGroup, selectedMaterial, newFilteredMaterials,currentModelMaterialSpecifications} = useSnapshot(configuratorState);
  
  const setActive = (value) => {
    // set active material
    setSelectedMaterial(value);
    setFinish(activeWall,value);
    setCurrentModelMaterialSpecifications(partSelected, [selectedMaterialGroup, value]);
  }

  useEffect(()=>{
    console.log(currentModelMaterialSpecifications[partSelected]);
  })
  
  return (
    <ul className="swatch-nav">
      {newFilteredMaterials.map((value, index) => {
        return (
          <li key={index} style={{width:170, height:99}} className={`swatch-container ${currentModelMaterialSpecifications[partSelected][1]===value.title?"selected":""}` }
              onClick={() => setActive(value.title, index)}>
            <SwatchBtn indexNo={index} value={value}/>
          </li>
        )
      })}
    </ul>
  );
};

export default SwatchesNavController;
